module.exports = __webpack_public_path__ + "static/img/pocketMoney-icon.0cdab256.png";